import React, { useEffect, useState } from "react"
import {
  Card,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import LoadingButton from "../../../components/Common/LoadingButton"
import {
  fetchSupplier,
  tradeDocDownload,
  tradeDocGetBlobUrl,
} from "../../../services/procurement/supplier"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import DownloadIcon from "../../../assets/icons/download.svg"
import ViewIcon from "../../../assets/icons/document-view.svg"
import closeIcon from "../../../assets/icons/close.svg"
import NumberFormat from "../../../utils/numberFormat"
import MobileNumberFormat from "../../../utils/mobilenumberformat"

const ViewSupplier = ({ fromDashboard, viewValue }) => {
  const companyname = localStorage.getItem("companyname")
  document.title = `Supplier${companyname ? ` | ${companyname}` : "MEP -Hub"}`

  const locations = useLocation();
  const crumb = locations?.state?.menuLabel || ""

  const [supplier, setSupplier] = useState()
  const { id } = useParams()
  const navigate = useNavigate()

  const imgUrl = process.env.REACT_APP_IMG_APIKEY

  const [modal, setModal] = useState(false)
  const [fileView, setFileView] = useState()
  const desimalrange = localStorage.getItem("desimalrange")

  const ViewId = fromDashboard ? viewValue?.value?.supplier_id : id
  console.log("viewValue  :", viewValue)

  useEffect(() => {
    const fetchData = async id => {
      const response = await fetchSupplier(id)
      setSupplier(response?.data)
    }
    fetchData(ViewId)
  }, [])

  const handleTradeDownload = ({ path, url, downloadName, extension }) => {
    const handleDownload = async () => {
      const responce = await tradeDocDownload({
        url: url,
        path,
        downloadName: downloadName,
        extension: extension,
      })
    }
    handleDownload()
  }

  const getExtension = filePath => {
    const parts = filePath.split(".")
    return parts[1]
  }

  // const toggle = type => {
  //   setModal(!modal)
  //   setFileView(
  //     type?.type == "vat"
  //       ? supplier?.vat?.[0]?.file_path
  //       : type?.type == "trade"
  //       ? supplier?.trade?.[0]?.file_path
  //       : supplier?.vendor_document
  //   )
  //   console.log(`comingin`, type?.type == "vat" ? supplier?.vat?.[0]?.file_path : type?.type == "trade" ? supplier?.trade?.[0]?.file_path : supplier?.vendor_document)
  // }

  // const toggle = async type => {
  //   try {
  //     setModal(!modal)
  //     const filePath =
  //       type?.type === "vat"
  //         ? supplier?.vat?.[0]?.file_path
  //         : type?.type === "trade"
  //         ? supplier?.trade?.[0]?.file_path
  //         : supplier?.vendor_document

  //     // Ensure proper URL construction
  //     let fullUrl = ""
  //     if (filePath) {
  //       // Handle cases where filePath might already include the base URL
  //       fullUrl = filePath.startsWith("http")
  //         ? filePath
  //         : `${imgUrl}${filePath.startsWith("/") ? "" : "/"}${filePath}`

  //       // Add cache busting parameter to prevent iframe caching issues
  //       fullUrl += `${fullUrl.includes("?") ? "&" : "?"}_=${Date.now()}`
  //     }
  //     setFileView(fullUrl || null)
  //   } catch (error) {
  //     console.error("Error handling document view:", error)
  //     setFileView(null)
  //   }
  // }

  const toggle = async type => {
    try {
      setModal(!modal)

      let url = ""

      if (type?.type === "vat") {
        url = `suppliers-trade-download/${supplier?.vat?.[0]?.id}`
      } else if (type?.type === "trade") {
        url = `suppliers-trade-download/${supplier?.trade?.[0]?.id}`
      } else if (type?.type === "vendor") {
        url = `/supplier/${supplier?.id}/download/vendor-document`
      }

      if (url) {
        const blobUrl = await tradeDocGetBlobUrl({ url })
        setFileView(blobUrl)
      } else {
        setFileView(null)
      }
    } catch (error) {
      console.error("Error handling document view:", error)
      setFileView(null)
    }
  }

  return (
    <React.Fragment>
      <div className={`page-content ${fromDashboard && "pt-0"}`}>
        <div className="container-fluid">
          <div className="d-flex justify-content-between me-2">
            {!fromDashboard && (
              <Breadcrumbs
                title="Procurement"
                breadcrumbObject={[
                  { title: "Procurement", link: "/procurement" },
                  { title: crumb || "Masters", link: "/procurement" },
                  { title: "Suppliers", link: "/procurement-supplier" },
                  {
                    title: "View Supplier",
                    link: "",
                  },
                ]}
              />
            )}
            {!fromDashboard && (
              <LoadingButton
                form={`supplier-form`}
                color={"primary"}
                className={"px-2 mb-3 btn btn-primary"}
                type="submit"
                onClick={() => navigate(`/procurement-supplier/edit/${ViewId}`)}
              >
                Edit
              </LoadingButton>
            )}
          </div>
          <Container fluid className="ps-lg-0">
            <Card className="supplier-card">
              <div className="supplier-view-head px-4 py-2">
                Supplier Details
              </div>
              <Row className="px-4 py-5">
                <Col sm={11}>
                  <Row>
                    <Col lg={2} md={4} sm={6}>
                      <div className="supplier-td-head">Supplier code</div>
                      <div className="supplier-td-body">
                        {supplier ? supplier?.suppliers_code : "-"}
                      </div>
                    </Col>
                    <Col lg={2} md={4} sm={6}>
                      <div className="supplier-td-head">Supplier name</div>
                      <div className="supplier-td-body capitalize-letter">
                        {supplier ? supplier?.name : "-"}
                      </div>
                    </Col>
                    <Col lg={2} md={4} sm={6}>
                      <div className="supplier-td-head">Email id</div>
                      <div className="supplier-td-body">
                        {supplier?.email_id ? supplier?.email_id : "-"}
                      </div>
                    </Col>
                    <Col lg={2} md={4} sm={6}>
                      <div className="supplier-td-head">Contact number</div>
                      <div className="supplier-td-body">
                        {supplier?.contact_number
                          ? MobileNumberFormat("+" + supplier?.contact_number)
                          : "-"}
                      </div>
                    </Col>
                    <Col lg={2} md={4} sm={6}>
                      <div className="supplier-td-head">Country</div>
                      <div className="supplier-td-body">
                        {supplier?.country ? supplier?.country?.name : "-"}
                      </div>
                    </Col>
                    {/* <Col lg={2} md={4} sm={6}>
                      <div className="supplier-td-head">Payment Mode</div>
                      <div className="supplier-td-body">
                        {supplier ? supplier?.payment?.name : "-"}
                      </div>
                    </Col> */}
                    <Col lg={2} md={4} sm={6}>
                      <div className="supplier-td-head">Credit Period</div>
                      <div className="supplier-td-body">
                        {supplier?.credit_period?.id
                          ? supplier?.credit_period?.period == 0
                            ? "Immediate"
                            : `${supplier?.credit_period?.period} ${
                                supplier?.credit_period?.unit == "days"
                                  ? supplier?.credit_period?.period > 1
                                    ? "Days"
                                    : "Day"
                                  : supplier?.credit_period?.period > 1
                                  ? "Months"
                                  : "Months"
                              }`
                          : "-"}
                      </div>
                    </Col>
                  </Row>
                  <Row className="pt-3">
                    <Col lg={2} md={4} sm={6}>
                      <div className="supplier-td-head">Currency</div>
                      <div className="supplier-td-body">
                        {supplier?.currency ? supplier?.currency?.name : "-"}
                      </div>
                    </Col>
                    <Col lg={2} md={4} sm={6}>
                      <div className="supplier-td-head">VAT No</div>
                      <div className="supplier-td-body">
                        {supplier?.vat_no ? supplier?.vat_no : "-"}
                      </div>
                    </Col>
                    <Col lg={2} md={4} sm={6}>
                      <div className="supplier-td-head">Address</div>
                      <div className="supplier-td-body capitalize-letter">
                        {supplier?.address ? supplier?.address : "-"}
                      </div>
                    </Col>
                    {supplier?.vat?.length ? (
                      <Col lg={2} md={4} sm={6}>
                        <div className="supplier-td-head">VAT Certificate</div>
                        <div className="supplier-td-body supplier-file">
                          {supplier ? (
                            <>
                              <span
                                className="pointer view-eye"
                                onClick={() => toggle({ type: "vat" })}
                              >
                                <img src={ViewIcon} alt="file" />
                              </span>
                              <span
                                className="pointer view-eye"
                                onClick={() => {
                                  handleTradeDownload({
                                    id: supplier?.vat?.[0]?.id,
                                    path: supplier?.vat?.[0]?.file_path
                                      ?.split("/")
                                      .pop(),
                                    url: `suppliers-trade-download/${supplier?.vat?.[0]?.id}`,
                                    downloadName: "VAT_Certificate",
                                    extension: getExtension(
                                      supplier?.vat?.[0]?.file_path
                                    ),
                                  })
                                }}
                              >
                                <img src={DownloadIcon} alt="file" />
                              </span>
                            </>
                          ) : (
                            "-"
                          )}
                          {/* <span
                          className="pointer"
                          onClick={() => {
                            handleTradeDownload({
                              id: supplier?.vat?.[0]?.id,
                              path: supplier?.vat?.[0]?.file_path
                                ?.split("/")
                                .pop(),
                              url: `suppliers-trade-download/${supplier?.vat?.[0]?.id}`,
                              downloadName: "VAT_Certificate",
                              extension: getExtension(
                                supplier?.vat?.[0]?.file_path
                              ),
                            })
                          }}
                        >
                          {supplier
                            ? supplier?.vat?.[0]?.file_path?.split("/").pop()
                            : "-"}
                        </span> */}
                        </div>
                      </Col>
                    ) : (
                      <></>
                    )}
                    {supplier?.trade?.length ? (
                      <Col lg={2} md={4} sm={6}>
                        <div className="supplier-td-head">Trade Licence</div>
                        <div className="supplier-td-body supplier-file">
                          {supplier ? (
                            <>
                              <span
                                className="pointer view-eye"
                                onClick={() => toggle({ type: "trade" })}
                              >
                                <img src={ViewIcon} alt="file" />
                              </span>
                              <span
                                className="pointer view-eye"
                                onClick={() => {
                                  handleTradeDownload({
                                    id: supplier?.trade?.[0]?.id,
                                    path: supplier?.trade?.[0]?.file_path
                                      ?.split("/")
                                      .pop(),
                                    url: `suppliers-trade-download/${supplier?.trade?.[0]?.id}`,
                                    downloadName: "Trade_Licence",
                                    extension: getExtension(
                                      supplier?.trade?.[0]?.file_path
                                    ),
                                  })
                                }}
                              >
                                <img src={DownloadIcon} />
                              </span>
                            </>
                          ) : (
                            "-"
                          )}
                          {/* <span
                          className="pointer"
                          onClick={() => {
                            handleTradeDownload({
                              id: supplier?.trade?.[0]?.id,
                              path: supplier?.trade?.[0]?.file_path
                                ?.split("/")
                                .pop(),
                              url: `suppliers-trade-download/${supplier?.trade?.[0]?.id}`,
                              downloadName: "Trade_Licence",
                              extension: getExtension(
                                supplier?.trade?.[0]?.file_path
                              ),
                            })
                          }}
                        >
                          {supplier
                            ? supplier?.trade?.[0]?.file_path?.split("/").pop()
                            : "-"}
                        </span> */}
                        </div>
                      </Col>
                    ) : (
                      <></>
                    )}
                    {supplier?.vendor_document != null && (
                      <Col lg={2} md={4} sm={6}>
                        <div className="supplier-td-head">Vendor Document</div>
                        <div className="supplier-td-body supplier-file">
                          {supplier ? (
                            <>
                              <span
                                className="pointer view-eye"
                                onClick={() => toggle({ type: "vendor" })}
                              >
                                <img src={ViewIcon} />
                              </span>
                              <span
                                className="pointer view-eye"
                                onClick={() => {
                                  handleTradeDownload({
                                    id: supplier?.id,
                                    path: supplier?.vendor_document
                                      ?.split("/")
                                      .pop(),
                                    url: `/supplier/${supplier?.id}/download/vendor-document`,
                                    downloadName: "Vendor_Document",
                                    extension: getExtension(
                                      supplier?.vendor_document
                                    ),
                                  })
                                }}
                              >
                                <img src={DownloadIcon} />
                              </span>
                            </>
                          ) : (
                            "-"
                          )}
                        </div>
                      </Col>
                    )}
                  </Row>
                </Col>
              </Row>
              <div className="supplier-sub-view-head px-4 py-2">
                Contact Person
              </div>
              <Row className="px-4 ">
                <Col lg={11} md={12}>
                  {supplier?.contact?.map((dt, index) => (
                    <Row key={`contact${index}`}>
                      <Col
                        lg={2}
                        md={6}
                        className={`${
                          supplier?.contact.length > 1 &&
                          index + 1 < supplier?.contact.length
                            ? "table-border-line py-4"
                            : "py-4"
                        }`}
                      >
                        <div className="supplier-td-head">Contact Name</div>
                        <div className="supplier-td-body">
                          {dt?.supplier_contact_name
                            ? dt?.supplier_contact_name
                            : "-"}
                        </div>
                      </Col>
                      <Col
                        lg={2}
                        md={6}
                        className={`${
                          supplier?.contact.length > 1 &&
                          index + 1 < supplier?.contact.length
                            ? "table-border-line py-4"
                            : "py-4"
                        }`}
                      >
                        <div className="supplier-td-head">Contact Email ID</div>
                        <div className="supplier-td-body">
                          {dt?.email_id ? dt?.email_id : "-"}
                        </div>
                      </Col>
                      <Col
                        lg={2}
                        md={6}
                        className={`${
                          supplier?.contact.length > 1 &&
                          index + 1 < supplier?.contact.length
                            ? "table-border-line py-4"
                            : "py-4"
                        }`}
                      >
                        <div className="supplier-td-head">
                          Contact Designation
                        </div>
                        <div className="supplier-td-body">
                          {dt?.designation ? dt?.designation : "-"}
                        </div>
                      </Col>
                      <Col
                        lg={2}
                        md={6}
                        className={`${
                          supplier?.contact.length > 1 &&
                          index + 1 < supplier?.contact.length
                            ? "table-border-line py-4"
                            : "py-4"
                        }`}
                      >
                        <div className="supplier-td-head">
                          Contact Phone Number
                        </div>
                        <div className="supplier-td-body">
                          {dt?.phone_no
                            ? MobileNumberFormat("+" + dt?.phone_no)
                            : "-"}
                        </div>
                      </Col>
                    </Row>
                  ))}
                </Col>
              </Row>
              {supplier && (
                <>
                  <div className="supplier-sub-view-head px-4 py-2">
                    Bank Details
                  </div>
                  <Row className="px-4">
                    <Col lg={11}>
                      {/* Show at least one bank details row, even if empty */}
                      {(supplier?.bank_details?.length > 0
                        ? supplier.bank_details
                        : [{}]
                      ).map((dt, index) => (
                        <Row key={`bankDetail${index}`}>
                          <Col
                            lg={2}
                            className={`${
                              supplier?.bank_details?.length > 1 &&
                              index + 1 < supplier?.bank_details?.length
                                ? "table-border-line py-4"
                                : "py-4"
                            }`}
                          >
                            <div className="supplier-td-head">
                              Account Holder Name
                            </div>
                            <div className="supplier-td-body">
                              {dt?.ac_holder_name
                                ? dt?.ac_holder_name
                                : "-" || "-"}
                            </div>
                          </Col>
                          <Col
                            lg={2}
                            className={`${
                              supplier?.bank_details?.length > 1 &&
                              index + 1 < supplier?.bank_details?.length
                                ? "table-border-line py-4"
                                : "py-4"
                            }`}
                          >
                            <div className="supplier-td-head">
                              Account Number
                            </div>
                            <div className="supplier-td-body">
                              {dt?.ac_number ? dt?.ac_number : "-" || "-"}
                            </div>
                          </Col>
                          <Col
                            lg={2}
                            className={`${
                              supplier?.bank_details?.length > 1 &&
                              index + 1 < supplier?.bank_details?.length
                                ? "table-border-line py-4"
                                : "py-4"
                            }`}
                          >
                            <div className="supplier-td-head">Bank Name</div>
                            <div className="supplier-td-body">
                              {dt?.banks?.label ? dt?.banks?.label : "-" || "-"}
                            </div>
                          </Col>
                          <Col
                            lg={2}
                            className={`${
                              supplier?.bank_details?.length > 1 &&
                              index + 1 < supplier?.bank_details?.length
                                ? "table-border-line py-4"
                                : "py-4"
                            }`}
                          >
                            <div className="supplier-td-head">Branch Name</div>
                            <div className="supplier-td-body">
                              {dt?.branch_name ? dt?.branch_name : "-" || "-"}
                            </div>
                          </Col>
                          <Col
                            lg={2}
                            className={`${
                              supplier?.bank_details?.length > 1 &&
                              index + 1 < supplier?.bank_details?.length
                                ? "table-border-line py-4"
                                : "py-4"
                            }`}
                          >
                            <div className="supplier-td-head">IBAN</div>
                            <div className="supplier-td-body">
                              {dt?.iban ? dt?.iban : "-" || "-"}
                            </div>
                          </Col>
                          <Col
                            lg={2}
                            className={`${
                              supplier?.bank_details?.length > 1 &&
                              index + 1 < supplier?.bank_details?.length
                                ? "table-border-line py-4"
                                : "py-4"
                            }`}
                          >
                            <div className="supplier-td-head">
                              SWIFT/BIC Code
                            </div>
                            <div className="supplier-td-body">
                              {dt?.swift_code ? dt?.swift_code : "-" || "-"}
                            </div>
                          </Col>
                        </Row>
                      ))}
                      <Row>
                        <Col lg={2} className="py-4">
                          <div className="supplier-td-head">
                            Opening Balance
                          </div>
                          <div className="supplier-td-body">
                            {supplier?.ledger?.opening_balance
                              ? NumberFormat(
                                  Number(supplier?.ledger?.opening_balance),
                                  desimalrange,
                                  desimalrange
                                )
                              : "0.000"}
                          </div>
                        </Col>
                        <Col lg={2} className="py-4">
                          <div className="supplier-td-head">Balance Type</div>
                          <div className="supplier-td-body">
                            {supplier?.ledger?.balance_type || "-"}
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </>
              )}
            </Card>
          </Container>
        </div>
      </div>
      {/* <Modal isOpen={modal} toggle={toggle} size="lg">
        <ModalHeader className="custom-modal-header">
          <div className="d-flex justify-content-between">
            <h5>{"View File"}</h5>
            <img
              src={closeIcon}
              alt=""
              onClick={() => setModal(false)}
              width="10"
              role="button"
            />
          </div>
        </ModalHeader>

        <ModalBody className="modal-iframe">
          <iframe
            title="File Viewer"
            src={`${imgUrl}${fileView}`}
            className="iframe-view"
            sandbox="allow-same-origin allow-scripts"
          />
        </ModalBody>
      </Modal> */}
      <Modal isOpen={modal} toggle={() => setModal(false)} size="lg" centered>
        <ModalHeader className="custom-modal-header">
          <div className="d-flex justify-content-between align-items-center w-100">
            <h5 className="mb-0">Document Viewer</h5>
            <button
              type="button"
              className="btn-close"
              onClick={() => setModal(false)}
              aria-label="Close"
            ></button>
          </div>
        </ModalHeader>
        <ModalBody className="modal-iframe p-0">
          {console.log(`fileView`, fileView)}
          {fileView ? (
            <>
              {/* Fallback content for unsupported file types */}
              {/* <iframe
          key={fileView} // Force re-render when URL changes
          title="Document Viewer"
          src={fileView}
          className="w-100 border-0"
          style={{ height: '70vh' }}
          sandbox="allow-same-origin allow-scripts allow-popups"
          onError={(e) => {
            console.error('Iframe load error:', e);
            setFileView(null);
          }}
        /> */}
              <div style={{ minHeight: "100%" }}>
                <object
                  data={fileView}
                  type="application/pdf"
                  width="100%"
                  height="100%"
                  style={{ minHeight: "70vh" }}
                >
                  <p>
                    PDF cannot be displayed.
                    <a
                      href={fileView}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Open in new tab
                    </a>
                  </p>
                </object>
              </div>
              {/* <div className="text-center mt-2">
          <a 
            href={fileView} 
            target="_blank" 
            rel="noopener noreferrer"
            className="btn btn-sm btn-primary"
          >
            Open in New Tab
          </a>
        </div> */}
            </>
          ) : (
            <div className="d-flex flex-column align-items-center justify-content-center p-5">
              <div className="text-muted mb-3">Document not available</div>
              <button
                className="btn btn-sm btn-outline-secondary"
                onClick={() => setModal(false)}
              >
                Close
              </button>
            </div>
          )}
        </ModalBody>
      </Modal>
    </React.Fragment>
  )
}

export default ViewSupplier
